// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"bc104f61","519":"bc104f61"}[chunkId] + ".chunk.css";
};